import styled from 'styled-components';
import { getAuth } from 'firebase/auth';

const Slider = styled.div`
    margin: 0.5rem auto 0.25rem auto;
    width:100%;
    overflow: none;
    max-width: 500px;
`;

const Slides = styled.div`
    width:100%;
    padding:0 1rem;
`;

const Banner = styled.img`
    min-width:0;
    width: 100%;
    border-radius:10px;
`;

const TYPEFORM_BASE_URL = "https://form.typeform.com/to/AZgrcazl";
const BANNER_IMAGE_URL = "https://res.cloudinary.com/xook/image/upload/v1774973634/app.xook.ai/Feed_back_refund_npvbhf.png";

function getTypeformUrl(): string {
    const auth = getAuth();
    const userId = auth.currentUser?.uid;
    
    if (userId) {
        return `${TYPEFORM_BASE_URL}#user_Id=${userId}`;
    }
    
    return TYPEFORM_BASE_URL;
}

const PromoBanner = () => {
    // const typeformUrl = getTypeformUrl();
    
    return (
        <Slider className='no-scrollbar'>
            <Slides>
                {/* <a rel='noopener noreferrer' target="_blank" href={typeformUrl}>
                    <Banner src={BANNER_IMAGE_URL} />
                </a> */}
                <Banner src={BANNER_IMAGE_URL} />
            </Slides>
        </Slider>
    );
};

export default PromoBanner;
